/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit HolderFirstName/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function HolderFirstName({
  children,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderCaptureMethod/Content/ExtraFields/Bluefin/Card/HolderFirstName",
  onChange,
  isInvalid,
  isSubmitting
  
}) {
let paymentCreditCardHolderFirstNameValueData = fromData.useDataValue({ viewPath,
context: 'payment',
path: 'credit_card.holder_first_name',
})
let paymentCreditCardHolderFirstNameIsValidData = fromData.useDataIsValid({ viewPath,
context: 'payment',
path: 'credit_card.holder_first_name',
validate: fromValidate.name,
required: true,
})
let paymentCreditCardHolderFirstNameChangeData = fromData.useDataChange({ viewPath,
context: 'payment',
path: 'credit_card.holder_first_name',
})
let paymentCreditCardHolderFirstNameIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'payment',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="payment.credit_card.holder_first_name"
 validate="/Data/validate.js name"
 required={true}
 value={paymentCreditCardHolderFirstNameValueData}
 onChange={paymentCreditCardHolderFirstNameChangeData}
 invalid={!paymentCreditCardHolderFirstNameIsValidData}
 invalidMessage="Please input card holder's first name"
 disabled={paymentCreditCardHolderFirstNameIsSubmittingData}
 marginTop={dtSpaceS}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="First name"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 placeholder="Card holder's first name"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}